import { requestChannelDetail, requestChannelVendorDetails } from "application/merchandise/merchandiseActions";
import { RequestState } from "common/RequestState";
import { isInProgress, isLoading, isNotRequested } from "helpers/requestStateHelper";
import { vendor } from "helpers/vendorHelper";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleError } from "services/errorService";

export const useChannel = (options = {}) => {
  //we will use vendorId as a preference or else use vendorName (default to url based vendorName)
  const { vendorId = null, vendorName = vendor } = options;

  const [channel, setChannel] = useState({ requestState: RequestState.NotRequested });
  const channels = useSelector(state => state.merchandise);
  const locale = useSelector(state => state.locale);
  const dispatch = useDispatch();
  const config = useSelector(state => state.config);

  const IdByVendor = vendorName => {
    let result = null;
    Object.keys(channels).forEach(channelId => {
      const vendor = channels[channelId].ID;
      if (vendor === vendorName) result = channelId;
    });
    return result;
  };

  useEffect(() => {
    if (isLoading(config)) return;
    //either request or wait
    if (isNotRequested(channels)) {
      dispatch(requestChannelVendorDetails());
    }
    if (isLoading(channels)) {
      return;
    }
    //if we haven't specified vendor id we lookup the id for vendor name
    const channelId = vendorId || IdByVendor(vendorName);

    //Channels are loaded, try and find the current channel
    let tempChannel = channels[channelId];
    if (!tempChannel) {
      handleError({ message: `Channel Not Found ${vendorName} ${channelId} ${locale.localeId}` });
    }

    //either request or wait
    if (isNotRequested(tempChannel)) {
      dispatch(requestChannelDetail(channelId, locale.localeId));
    }
    if (isInProgress(tempChannel)) {
      return;
    }
    setChannel(tempChannel);
  }, [config, channels, locale, vendorId, vendorName]);

  return channel;
};
